import {
  CsvExportRow,
  SubscriptionType
} from 'screens/SubscriptionsAndDatabases/utils/sharedBdbTableTypes';

interface DatabaseCsvHeader {
  label: string;
  key: keyof CsvExportRow;
}

export const databasesCsvHeaders: DatabaseCsvHeader[] = [
  { label: 'Status', key: 'status' },
  { label: 'Database ID', key: 'id' },
  { label: 'Database name', key: 'name' },
  { label: 'Subscription ID', key: 'subscriptionId' },
  { label: 'Subscription name', key: 'subscriptionName' },
  { label: 'Subscription type', key: 'subscriptionType' },
  { label: 'Region', key: 'region' },
  { label: 'Public endpoint', key: 'dnsMasterPublic' },
  { label: 'Private endpoint', key: 'dnsMasterPrivate' },
  { label: 'Memory limit (MB)', key: 'memoryLimit' },
  { label: 'Memory used (MB)', key: 'memoryUsed' },
  { label: 'Throughput (Ops/sec)', key: 'throughput' },
  { label: 'Capabilities', key: 'modules' },
  { label: 'Options', key: 'dbOptions' },
  { label: 'Shard type', key: 'shardTypeName' },
  { label: 'Shard count', key: 'shardsCount' },
  { label: 'Shard price ($/hr)', key: 'shardPrice' },
  { label: 'Database price ($/hr)', key: 'totalShardsPrice' }
];

export const DB_TABLE_PERSISTENCE_SEARCH = 'dbTablePersistence-search';
export const DB_TABLE_PERSISTENCE_FILTERS = 'dbTablePersistence-filters';
export const DB_TABLE_PERSISTENCE_SORTING = 'dbTablePersistence-sorting';

export const subscriptionsTypesMap: Record<SubscriptionType, string> = {
  essentials: 'Essentials',
  redisFlex: 'Redis Flex',
  pro: 'Pro',
  proRof: 'Auto-Tiering',
  dedicated: 'Dedicated'
};

const subscriptionsTypesMapFlexPro: Record<SubscriptionType, string> = {
  essentials: 'Essentials',
  redisFlex: 'Redis Flex (Ess.)',
  pro: 'Pro',
  proRof: 'Redis Flex (Pro.)',
  dedicated: 'Dedicated'
};

export const getSubscriptionTypeLabel = (
  subType: SubscriptionType,
  enableRedisFlexPro?: boolean
): string => {
  return enableRedisFlexPro
    ? subscriptionsTypesMapFlexPro[subType]
    : subscriptionsTypesMap[subType];
};
